import { gql } from 'graphql-request'

export namespace PinnedHomesMutations {
  export function createPinnedHome() {
    return gql`
      mutation createPinnedHome($pinnedHome: PinnedHomeInsertMutation) {
        createPinnedHome(pinnedHome: $pinnedHome) {
          id
        }
      }
    `
  }

  export function removePinnedHome() {
    return gql`
      mutation removePinnedHome($pinnedHomes: HomesToUnpin) {
        unpinHomes(pinnedHomes: $pinnedHomes) {
          id
        }
      }
    `
  }
}
